/**
 * Утилита-мост для безопасной передачи данных из webview в нативное приложение.
 *
 * iOS:   window.webkit.messageHandlers.checkoutBridge.postMessage({ action, payload })
 * Android: window.AndroidBridge.postMessage(JSON.stringify({ action, payload }))
 *
 * Обёрнуто в try/catch — в обычном браузере вызовы молча игнорируются.
 */
export function sendToNative(action, payload = {}) {
  try {
    // iOS
    if (window.webkit?.messageHandlers?.checkoutBridge) {
      window.webkit.messageHandlers.checkoutBridge.postMessage({
        action,
        payload,
      })
    }

    // Android
    if (window.AndroidBridge?.postMessage) {
      window.AndroidBridge.postMessage(JSON.stringify({ action, payload }))
    }
  } catch (e) {
    console.error('Native bridge error:', e)
  }
}
